module.exports = __webpack_public_path__ + "static/img/6.481fae10.png";